import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { resetStatus } from "../redux/organizationsSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { ErrorList } from "../../../../components/ErrorList";
import { showToast } from "../../../../utils/showToast";
import { useError } from "../../../../hooks/useError";
import { useOrganizationEdit } from "../hooks/useOrganizationEdit";
import { TABS } from "../constants";

export const Edit = ({ isOpen, onClose, selected: { id, businessName: name } }) => {
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("General");

  const {
    register,
    control,
    formState: { errors, dirtyFields, isLoading },
    watchedValues,
    submit,
    currentOrganizationInfo,
    setCurrentOrganizationInfo
  } = useOrganizationEdit({ id });

  const [showFutureAppointments, membershipMetric] = watchedValues;

  const close = () => {
    dispatch(resetStatus());
    onClose();
    setCurrentOrganizationInfo({});
  };

  const { errors: serverErrors, status } = useError({
    cb: () => {
      showToast("Organization was successfully edited");
      close();
    },
    sliceKey: "organizations"
  });

  const primaryButtonDisabled =
    (dirtyFields && Object.keys(dirtyFields).length === 0) || status == "pending";

  const renderActiveTab = () => {
    let Component = TABS[activeTab];

    let retentionProps = activeTab === "Retention" ? { showFutureAppointments } : {};

    let clubreadyProps =
      activeTab === "ClubReady"
        ? {
            membershipMetric,
            isEditMode: true,
            agreementNamesWithZeroSales: currentOrganizationInfo.agreementNamesWithZeroSales
          }
        : {};

    let generalProps =
      activeTab === "General"
        ? {
            orgRoles: currentOrganizationInfo.roles,
            isEditMode: true
          }
        : {};

    return (
      <Component
        register={register}
        control={control}
        {...retentionProps}
        {...clubreadyProps}
        {...generalProps}
      />
    );
  };

  return (
    <>
      <MainModal
        isLoading={isLoading}
        isOpen={isOpen}
        onClose={close}
        parentSelector=".admin-organizations"
        headerText={`Edit Organization ${name}`}
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={submit}
        containerClassName="add"
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        height={645}
        width={900}
      >
        <div className="tabs">
          <div className="tabs__list">
            {Object.entries(TABS).map(([tabName]) => (
              <button
                key={tabName}
                className={`tabs__tab ${activeTab === tabName ? "tabs__tab--active" : ""}`}
                onClick={() => setActiveTab(tabName)}
              >
                {tabName}
              </button>
            ))}
          </div>

          <div>{renderActiveTab()}</div>
        </div>

        {status === "pending" && <LoadingAnimation uiLoader />}
        <ErrorList errors={{ ...errors, ...serverErrors }} />
      </MainModal>
    </>
  );
};
